/**
 * Archive template
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from './lib/global';
import Logger from './lib/logger';

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Archive';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/
const init = () => {
  Logger.log(`${NAME} > loaded`);
}

// Bootstrap global functionality
Global();

// Bootstrap page-specific functionality
init();

// Do not edit below this line...
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒
Logger.log(`${NAME} > loaded`);
